const collect = [
    {
        path: '/collect/gateway',
        name: 'collectGateway',
        component: () => import('@/view/collect/gateway'),
    },
    {
        path: '/collect/device',
        name: 'collectDevice',
        component: () => import('@/view/collect/device'),
    },
    {
        path: '/collect/wave',
        name: 'collectWave',
        component: () => import('@/view/collect/wave'),
    }
]
export default collect